import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const QuantityInputContext = createContext({
    id: 'quantity-input',
    disabled: false,
});
export const QuantityInputProvider = ({ children, value, }) => {
    return _jsx(QuantityInputContext.Provider, { value: value, children: children });
};
export const useQuantityInputContext = () => {
    const ctx = useContext(QuantityInputContext);
    if (!ctx) {
        throw new Error('useQuantityInputContext can only be used inside QuantityInputContext.Provider');
    }
    return ctx;
};
//# sourceMappingURL=context.js.map